// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__dRRfl","select":"Header_select__UE6eC","clinic":"Header_clinic__3PSoN"};